import * as echarts from 'echarts';

export default (function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(['exports', 'echarts'], factory);
	} else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
		// CommonJS
		factory(exports, require('echarts'));
	} else {
		// Browser globals
		factory({}, echarts);
	}
}(echarts, function (exports, echarts) {
	var log = function (msg) {
		if (typeof console !== 'undefined') {
			console && console.error && console.error(msg);
		}
	};
	if (!echarts) {
		log('ECharts is not Loaded');
		return;
	}

	var colorPalette = [
		'#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80',
		'#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa',
		'#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050',
		'#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'
	];


	var themeMacarons = {
		color: colorPalette,
		title: {
			textStyle: {
				fontWeight: 'normal',
				color: '#008acd'
			}
		},

		visualMap: {
			itemWidth: 15,
			color: ['#5ab1ef', '#e0ffff']
		},

		toolbox: {
			iconStyle: {
				normal: {
					borderColor: colorPalette[0]
				}
			}
		},

		tooltip: {
			backgroundColor: 'rgba(50,50,50,0.6)',
			axisPointer: {
				type: 'line',
				lineStyle: {
					color: '#008acd'
				},
				crossStyle: {
					color: '#008acd'
				},
				shadowStyle: {
					color: 'rgba(200,200,200,0.2)'
				}
			}
		},

		dataZoom: {
			dataBackgroundColor: '#efefff',
			fillerColor: 'rgba(182,162,222,0.2)',
			handleColor: '#008acd'
		},

		grid: {
			borderColor: '#eee'
		},

		categoryAxis: {
			axisLine: {
				lineStyle: {
					color: '#008acd'
				}
			},
			splitLine: {
				lineStyle: {
					color: ['#eee']
				}
			}
		},

		valueAxis: {
			axisLine: {
				lineStyle: {
					color: '#008acd'
				}
			},
			splitArea: {
				show: true,
				areaStyle: {
					color: ['rgba(250,250,250,0.1)', 'rgba(200,200,200,0.1)']
				}
			},
			splitLine: {
				lineStyle: {
					color: ['#eee']
				}
			}
		},

		timeline: {
			lineStyle: {
				color: '#008acd'
			},
			controlStyle: {
				normal: { color: '#008acd' },
				emphasis: { color: '#008acd' }
			},
			symbol: 'emptyCircle',
			symbolSize: 3
		},

		line: {
			smooth: true,
			symbol: 'emptyCircle',
			symbolSize: 3
		},

		candlestick: {
			itemStyle: {
				normal: {
					color: '#d87a80',
					color0: '#2ec7c9',
					lineStyle: {
						color: '#d87a80',
						color0: '#2ec7c9'
					}
				}
			}
		},

		scatter: {
			symbol: 'circle',
			symbolSize: 4
		},

		map: {
			label: {
				normal: {
					textStyle: {
						color: '#d87a80'
					}
				}
			},
			itemStyle: {
				normal: {
					borderColor: '#eee',
					areaColor: '#ddd'
				},
				emphasis: {
					areaColor: '#fe994e'
				}
			}
		},

		graph: {
			color: colorPalette
		},

		gauge: {
			axisLine: {
				lineStyle: {
					color: [[0.2, '#2ec7c9'], [0.8, '#5ab1ef'], [1, '#d87a80']],
					width: 10
				}
			},
			axisTick: {
				splitNumber: 10,
				length: 15,
				lineStyle: {
					color: 'auto'
				}
			},
			splitLine: {
				length: 22,
				lineStyle: {
					color: 'auto'
				}
			},
			pointer: {
				width: 5
			}
		}
	};
	var themeWalden = {
		"color": [
				"#3fb1e3",
				"#6be6c1",
				"#626c91",
				"#a0a7e6",
				"#c4ebad",
				"#96dee8"
		],
		"backgroundColor": "rgba(252,252,252,0)",
		"textStyle": {},
		"title": {
				"textStyle": {
						"color": "#666666"
				},
				"subtextStyle": {
						"color": "#999999"
				}
		},
		"line": {
				"itemStyle": {
						"borderWidth": "2"
				},
				"lineStyle": {
						"width": "3"
				},
				"symbolSize": "8",
				"symbol": "emptyCircle",
				"smooth": false
		},
		"radar": {
				"itemStyle": {
						"borderWidth": "2"
				},
				"lineStyle": {
						"width": "3"
				},
				"symbolSize": "8",
				"symbol": "emptyCircle",
				"smooth": false
		},
		"bar": {
				"itemStyle": {
						"barBorderWidth": 0,
						"barBorderColor": "#ccc"
				}
		},
		"pie": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				}
		},
		"scatter": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				}
		},
		"boxplot": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				}
		},
		"parallel": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				}
		},
		"sankey": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				}
		},
		"funnel": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				}
		},
		"gauge": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				}
		},
		"candlestick": {
				"itemStyle": {
						"color": "#e6a0d2",
						"color0": "transparent",
						"borderColor": "#e6a0d2",
						"borderColor0": "#3fb1e3",
						"borderWidth": "2"
				}
		},
		"graph": {
				"itemStyle": {
						"borderWidth": 0,
						"borderColor": "#ccc"
				},
				"lineStyle": {
						"width": "1",
						"color": "#cccccc"
				},
				"symbolSize": "8",
				"symbol": "emptyCircle",
				"smooth": false,
				"color": [
						"#3fb1e3",
						"#6be6c1",
						"#626c91",
						"#a0a7e6",
						"#c4ebad",
						"#96dee8"
				],
				"label": {
						"color": "#ffffff"
				}
		},
		"map": {
				"itemStyle": {
						"areaColor": "#eeeeee",
						"borderColor": "#aaaaaa",
						"borderWidth": 0.5
				},
				"label": {
						"color": "#ffffff"
				},
				"emphasis": {
						"itemStyle": {
								"areaColor": "rgba(63,177,227,0.25)",
								"borderColor": "#3fb1e3",
								"borderWidth": 1
						},
						"label": {
								"color": "#3fb1e3"
						}
				}
		},
		"geo": {
				"itemStyle": {
						"areaColor": "#eeeeee",
						"borderColor": "#aaaaaa",
						"borderWidth": 0.5
				},
				"label": {
						"color": "#ffffff"
				},
				"emphasis": {
						"itemStyle": {
								"areaColor": "rgba(63,177,227,0.25)",
								"borderColor": "#3fb1e3",
								"borderWidth": 1
						},
						"label": {
								"color": "#3fb1e3"
						}
				}
		},
		"categoryAxis": {
				"axisLine": {
						"show": true,
						"lineStyle": {
								"color": "#cccccc"
						}
				},
				"axisTick": {
						"show": false,
						"lineStyle": {
								"color": "#333"
						}
				},
				"axisLabel": {
						"show": true,
						"color": "#999999"
				},
				"splitLine": {
						"show": true,
						"lineStyle": {
								"color": [
										"#eeeeee"
								]
						}
				},
				"splitArea": {
						"show": false,
						"areaStyle": {
								"color": [
										"rgba(250,250,250,0.05)",
										"rgba(200,200,200,0.02)"
								]
						}
				}
		},
		"valueAxis": {
				"axisLine": {
						"show": true,
						"lineStyle": {
								"color": "#cccccc"
						}
				},
				"axisTick": {
						"show": false,
						"lineStyle": {
								"color": "#333"
						}
				},
				"axisLabel": {
						"show": true,
						"color": "#999999"
				},
				"splitLine": {
						"show": true,
						"lineStyle": {
								"color": [
										"#eeeeee"
								]
						}
				},
				"splitArea": {
						"show": false,
						"areaStyle": {
								"color": [
										"rgba(250,250,250,0.05)",
										"rgba(200,200,200,0.02)"
								]
						}
				}
		},
		"logAxis": {
				"axisLine": {
						"show": true,
						"lineStyle": {
								"color": "#cccccc"
						}
				},
				"axisTick": {
						"show": false,
						"lineStyle": {
								"color": "#333"
						}
				},
				"axisLabel": {
						"show": true,
						"color": "#999999"
				},
				"splitLine": {
						"show": true,
						"lineStyle": {
								"color": [
										"#eeeeee"
								]
						}
				},
				"splitArea": {
						"show": false,
						"areaStyle": {
								"color": [
										"rgba(250,250,250,0.05)",
										"rgba(200,200,200,0.02)"
								]
						}
				}
		},
		"timeAxis": {
				"axisLine": {
						"show": true,
						"lineStyle": {
								"color": "#cccccc"
						}
				},
				"axisTick": {
						"show": false,
						"lineStyle": {
								"color": "#333"
						}
				},
				"axisLabel": {
						"show": true,
						"color": "#999999"
				},
				"splitLine": {
						"show": true,
						"lineStyle": {
								"color": [
										"#eeeeee"
								]
						}
				},
				"splitArea": {
						"show": false,
						"areaStyle": {
								"color": [
										"rgba(250,250,250,0.05)",
										"rgba(200,200,200,0.02)"
								]
						}
				}
		},
		"toolbox": {
				"iconStyle": {
						"borderColor": "#999999"
				},
				"emphasis": {
						"iconStyle": {
								"borderColor": "#666666"
						}
				}
		},
		"legend": {
				"textStyle": {
						"color": "#999999"
				}
		},
		"tooltip": {
				"axisPointer": {
						"lineStyle": {
								"color": "#cccccc",
								"width": 1
						},
						"crossStyle": {
								"color": "#cccccc",
								"width": 1
						}
				}
		},
		"timeline": {
				"lineStyle": {
						"color": "#626c91",
						"width": 1
				},
				"itemStyle": {
						"color": "#626c91",
						"borderWidth": 1
				},
				"controlStyle": {
						"color": "#626c91",
						"borderColor": "#626c91",
						"borderWidth": 0.5
				},
				"checkpointStyle": {
						"color": "#3fb1e3",
						"borderColor": "#3fb1e3"
				},
				"label": {
						"color": "#626c91"
				},
				"emphasis": {
						"itemStyle": {
								"color": "#626c91"
						},
						"controlStyle": {
								"color": "#626c91",
								"borderColor": "#626c91",
								"borderWidth": 0.5
						},
						"label": {
								"color": "#626c91"
						}
				}
		},
		"visualMap": {
				"color": [
						"#2a99c9",
						"#afe8ff"
				]
		},
		"dataZoom": {
				"backgroundColor": "rgba(255,255,255,0)",
				"dataBackgroundColor": "rgba(222,222,222,1)",
				"fillerColor": "rgba(114,230,212,0.25)",
				"handleColor": "#cccccc",
				"handleSize": "100%",
				"textStyle": {
						"color": "#999999"
				}
		},
		"markPoint": {
				"label": {
						"color": "#ffffff"
				},
				"emphasis": {
						"label": {
								"color": "#ffffff"
						}
				}
		}
}
	echarts.registerTheme('macarons', themeMacarons);
	echarts.registerTheme('walden', themeWalden);
}));